export default __webpack_public_path__ + "static/media/cashmax-mobile-all.9cccbfbd.png";